import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserStore } from '@/store/useUserStore'

import MotionDiv from '@/components/common/Motion/MotionDiv'
import MotionList from '@/components/common/Motion/MotionList'
import HeaderBack from '@/components/dashboard/Header/HeaderBack'

import QuickActionsModal from '@/components/dashboard/QuickActionsModal/QuickActionsModal'

import {
  PiArrowLeft,
  PiCaretRight,
  PiLockKey,
  PiSignOut,
  PiTrash,
  PiUser
} from 'react-icons/pi'

import useAuth from '@/hooks/useAuth'
import passwordsAPI from '@/services/api/passwords'
import usersAPI from '@/services/api/users'
import { usePageSetup } from '@/hooks/usePageSetup'

export const ProfileAccountPage = () => {
  const { t } = useTranslation()
  usePageSetup(t('profile.pageTitle.account'))
  const user = useUserStore((state) => state.user)
  const email = user?.email

  const navigate = useNavigate()
  const { logout } = useAuth()

  const [deleteOpen, setDeleteOpen] = useState(false)

  const items = [
    {
      id: "delete",
      title: t('profile.deleteAccount'),
      subtitle: "",
      value: <PiTrash className="h-4 w-4 text-zinc-900" />,
      icon: <PiUser className="h-6 w-6 text-zinc-900" />,
      groupId: "",
      props: {
        onClick: () => setDeleteOpen(true)
      }
    },
    {
      id: "password",
      title: t('profile.changePassword'),
      description: "",
      value: <PiCaretRight className="h-4 w-4 text-zinc-900" />,
      icon: <PiLockKey className="h-6 w-6 text-zinc-900" />,
      groupId: "",
      props: {
        onClick: async () => {
          if (!email) return

          await passwordsAPI.forgot({ email })
          navigate("/password/code", { state: { email } })
        }
      }
    },
    {
      id: "logout",
      title: t('common.logout'),
      description: "",
      value: <PiCaretRight className="h-4 w-4 text-zinc-900" />,
      icon: <PiSignOut className="h-6 w-6 text-zinc-900" />,
      groupId: "",
      props: {
        onClick: async () => {
          await logout()
          navigate("/")
        }
      }
    },
  ]

  const groups = [{ id: "", name: "", description: "" }]

  const deleteActions = [
    {
      icon: <div className='w-10 h-10 flex items-center justify-center bg-red-300 rounded-full'>
        <PiTrash className="w-5 h-5 text-[#1D2233]" />
      </div>,
      text: t('profile.confirmDeleteAccount'),
      subtext: t('profile.deleteAccountWarning'),
      onClick: () => usersAPI.destroy().then(async () => {
        await logout()
        navigate("/")
      }),
      className: "rounded-t-3xl rounded-b-xl"
    },
    {
      icon: <div className='w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full'>
        <PiArrowLeft className="w-5 h-5 text-[#1D2233]" />
      </div>,
      text: t('profile.goBack'),
      subtext: "",
      onClick: () => setDeleteOpen(false),
      className: "rounded-b-3xl rounded-t-xl"
    },
  ]

  return (
    <div className="h-full bg-white flex flex-col">
      <HeaderBack />
      <div className="flex-1 p-5 pt-2 pb-[4rem]">
        <MotionDiv className='mb-5'>
          <h1 className='text-base-black text-3xl font-semibold'>
            {t('profile.account')}
          </h1>
        </MotionDiv>
        <MotionList items={items} groups={groups} />
      </div>
      <QuickActionsModal
        actions={deleteActions}
        isOpen={deleteOpen}
        setOpen={setDeleteOpen}
      />
    </div>
  )
}

export default ProfileAccountPage